import React from "react";
import request, { gql } from "graphql-request";
import { useEffect, useState } from "react";
import BASEURL from "../../Utils/Baseurl";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import BarChatSkelton from "./BarChatSkelton";

const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];
const allUsersQuotationOpportunityCount = gql`
  query {
    allUsersQuotationOpportunityCount {
      username

      quotationCount

      opportunityCount
    }
  }
`;

const Chart = () => {
  const [barData, setBarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    setLoading(true);
    request(BASEURL, allUsersQuotationOpportunityCount)
      .then((res) => {
        // Transform the response data to match the chart's expected structure
        const transformedData = res.allUsersQuotationOpportunityCount.map(
          (item) => ({
            name: item.username,
            Quotationcount: item.quotationCount, // Customize key names to match chart requirements
            Opportunitycount: item.opportunityCount,
          })
        );

        setBarData(transformedData);
      })
      .finally(() => setLoading(false));
  }, []);
  const renderContent = () => {
    if (loading) return <BarChatSkelton />;
    if (error)
      return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;
    if (barData.length === 0)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            margin: "10px 0px",
          }}
        >
          <p>No Scheduled Appointment</p>
        </div>
      );

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin:'10px 0px'
        }}
      >
       
        <BarChart
          width={450}
          height={320}
          data={barData}
          margin={
            {
              // top: 5,
              // right: 5,
              // left: 20,
              // bottom: 5,
            }
          }
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar
            dataKey="Quotationcount"
            fill="#B3CDAD"
            activeBar={<Rectangle fill="pink" stroke="blue" />}
          />
          <Bar
            dataKey="Opportunitycount"
            fill="#FF5F5E"
            activeBar={<Rectangle fill="gold" stroke="purple" />}
          />
        </BarChart>
      </div>
    );
  };

  const demoUrl = "https://codesandbox.io/p/sandbox/simple-bar-chart-72d7y5";
  return <>{renderContent()}</>;
};

export default Chart;
